module.exports = __webpack_public_path__ + "static/media/walletConnect.8215855c.svg";